// extracted by mini-css-extract-plugin
export default {"wrapper":"search_wrapper__Po9xe"};